import { calculateViewportsSpatialRegistration } from "@cornerstonejs/core/utilities";
import {
  getAllViewports
} from "./CornerstoneViewportService";
import { getEnabledElement } from "@cornerstonejs/core";
import { SynchronizerManager } from "@cornerstonejs/tools";
import { createStackImageSynchronizer } from "@cornerstonejs/tools/synchronizers";

let STACK_IMAGE_SYNC_GROUPS_INFO = [];

const getOrCreateSynchronizer = (id) => {
  let synchronizer = SynchronizerManager.getSynchronizer(id);

  if (!synchronizer) {
    synchronizer = createStackImageSynchronizer(id);
  }

  return synchronizer;
};

export const enableStackScrollSync = async (viewportIndex) => {
  let viewports = await getAllViewports();

  viewports = viewports.filter(
    (viewport) =>
      viewport.getCurrentImageId() !== undefined &&
      viewport.type !== "orthographic" && !viewport.id.startsWith("thumbnail")
  );

  const viewportsByOrientation = viewports.reduce((acc, viewport) => {
    const { id: viewportId, type: viewportType, element } = viewport;

    if (viewportType !== "stack") {
      console.warn("Viewport is not a stack, cannot sync images yet");
      return acc;
    }

    // const { element } = cornerstoneViewportService.getViewportInfo(viewportId);
    const { viewport: csViewport, renderingEngineId } =
      getEnabledElement(element);
    const { viewPlaneNormal } = csViewport.getCamera();

    // Should we round here? I guess so, but not sure how much precision we need
    const orientation = viewPlaneNormal.map((v) => Math.round(v)).join(",");

    if (!acc[orientation]) {
      acc[orientation] = [];
    }

    acc[orientation].push({ viewportId, renderingEngineId, csViewport });

    return acc;
  }, {});

  Object.values(viewportsByOrientation).map((viewports) => {
    let synchronizerId = viewports
      .map(({ viewportId }) => viewportId)
      .join(",");

    synchronizerId = `imageSync_${synchronizerId}`;

    calculateViewportRegistration(viewports);

    viewports.forEach(({ viewportId, renderingEngineId }) => {
      addViewportToSyncGroup(viewportId, renderingEngineId, {
        id: synchronizerId,
        source: true,
        target: true,
      });
    });
    STACK_IMAGE_SYNC_GROUPS_INFO.push({
      synchronizerId,
      viewports,
    });
  });
};

export const disableStackScrollSync = async () => {
  STACK_IMAGE_SYNC_GROUPS_INFO.forEach((syncGroupInfo) => {
    const { viewports, synchronizerId } = syncGroupInfo;

    viewports.forEach(({ viewportId, renderingEngineId }) => {
      removeViewportFromSyncGroup(
        viewportId,
        renderingEngineId,
        synchronizerId
      );
    });
  });

  return;
};

const addViewportToSyncGroup = (viewportId, renderingEngineId, syncGroups) => {
  if (!syncGroups) {
    return;
  }

  const syncGroupsArray = Array.isArray(syncGroups) ? syncGroups : [syncGroups];

  syncGroupsArray.forEach((syncGroup) => {
    const { id, source, target } = syncGroup;
    const synchronizer = getOrCreateSynchronizer(id);

    const viewportInfo = { viewportId, renderingEngineId };
    console.log(viewportInfo);
    if (target && source) {
      synchronizer.add(viewportInfo);
      return;
    } else if (source) {
      synchronizer.addSource(viewportInfo);
    } else if (target) {
      synchronizer.addTarget(viewportInfo);
    }
  });
};

const removeViewportFromSyncGroup = (
  viewportId,
  renderingEngineId,
  syncGroupId
) => {
  const synchronizers = SynchronizerManager.getAllSynchronizers();

  const filteredSynchronizers = syncGroupId
    ? synchronizers.filter((s) => s.id === syncGroupId)
    : synchronizers;

  filteredSynchronizers.forEach((synchronizer) => {
    if (!synchronizer) {
      return;
    }

    synchronizer.remove({
      viewportId,
      renderingEngineId,
    });

    // check if any viewport is left in any of the sync groups, if not, delete that sync group
    const sourceViewports = synchronizer.getSourceViewports();
    const targetViewports = synchronizer.getTargetViewports();

    if (!sourceViewports.length && !targetViewports.length) {
      SynchronizerManager.destroySynchronizer(synchronizer.id);
    }
  });
};

const calculateViewportRegistration = (viewports) => {
  const viewportPairs = getViewportPairs(viewports);
  for (const [viewport, nextViewport] of viewportPairs) {
    const csViewport1 = viewport.csViewport;
    const csViewport2 = nextViewport.csViewport;

    calculateViewportsSpatialRegistration(csViewport1, csViewport2);
  }
};

const getViewportPairs = (viewports) => {
  const viewportPairs = [];

  //   for (let j = 0; j < target.length; j++) {
  //     viewportPairs.push([source, target[j]]);
  //   }

  for (let i = 0; i < viewports.length; i++) {
    for (let j = i + 1; j < viewports.length; j++) {
      viewportPairs.push([viewports[i], viewports[j]]);
    }
  }

  return viewportPairs;
};
